<script>
// import axios from "axios";

import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import {mapGetters, mapActions, mapState} from "vuex";
import CKEditor from "@ckeditor/ckeditor5-vue";
// eslint-disable-next-line no-unused-vars
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";

/**
 * Advanced table component
 */
export default {
  page: {
    title: "Radiology Patients",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
      ckeditor: CKEditor.component,
  },
  data() {
    return {
      title: "Radiology Patients",
      items: [
        {
          text: "Home",
          href: "#/",
        },
        {
          text: "Radiology Patients",
          active: true,
        },
      ],
      totalRows: 1,
        editor: ClassicEditor,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100, 200, 1000],
      filter: null,
      todoFilter: null,
        serviceReport:{
          report:'',
          id:'',
        },
      filterOn: [],
      todofilterOn: [],
      sortDesc: false,
        model_id: "",
      fields: [
        {
          key: "index",
          sortable: true,
          label: "S/N",
        },
        {
          key: "patient.patient_name",
          sortable: true,
          label: "NAME",
        },
        {
          key: "patient.patient_code",
          sortable: true,
          label: "NUMBER",
        },
        {
          key: "patient_services",
          sortable: true,
          label: "RADIOLOGY SERVICES",
        },
      ],
    };
  },
  computed: {
    ...mapGetters("doctor", ["RadiologyPatients", "RadioStatus"]),
      ...mapState("notification", [
          "notificationtype",
          "notification_message",
          "notification_show",
      ]),

    /**
     * Total no. of records
     */

    rows() {
      return this.RadiologyPatients ? this.RadiologyPatients.length : 1;
    },

    /**
     * Todo list of records
     */
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.RadiologyPatients ? this.RadiologyPatients.length : 1;
  },
    watch: {
        notification_show(newValue) {
            // Do whatever makes sense now
            if (newValue == true) {
                this.closeMode(this.model_id);
                if (this.notificationtype == "success") {
                    this.$toast.success(this.notification_message.msg);
                } else {
                    this.$toast.error(this.notification_message.msg);
                }
            }
        },
    },
  methods: {
    ...mapActions({
      FetchRadiologyPatients: "doctor/fetchRadiologyPatients",
        saveServiceReportResult: "doctor/addRadiologyResults",
    }),
    /**
     * Search the table data with search input
     */
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },

      showResultModal(service) {
          this.serviceReport.id = service.id;
          this.serviceReport.report=service.radio_report.radiology_report
      },

      //==RESET MODAL===========
      resetModal() {
          this.serviceReport.report = "";
          this.serviceReport.id = "";
      },

      saveServiceReport(modalId) {
          this.model_id = modalId;
          // dispatch the saving action
          this.saveServiceReportResult(this.serviceReport);
      },
      // CLOSE MODEL
      closeMode(model_id) {
          this.$nextTick(() => {
              this.$bvModal.hide(model_id);
          });
      },
  },
  created() {
    this.FetchRadiologyPatients();

  },
};
</script>

<template>
  <Layout>
      <Toasts
          :show-progress="true"
          :rtl="true"
          :max-messages="20"
          :time-out="3000"
          :closeable="false"
          :solid="true"
      ></Toasts>
    <PageHeader :title="title" :items="items" />

    <div class="row">
      <div class="col-12">
         <div class="card">
          <div class="card-body">
              <div class="card-body">
                  <div class="row mt-4">
                      <div class="col-sm-12 col-md-6">
                          <div id="tickets-table_length" class="dataTables_length">
                              <label class="d-inline-flex align-items-center">
                                  Show&nbsp;
                                  <b-form-select
                                          class="form-select form-select-sm"
                                          v-model="perPage"
                                          size="sm"
                                          :options="pageOptions"></b-form-select>&nbsp;entries
                              </label>
                          </div>
                      </div>
                      <!-- Search -->
                      <div class="col-sm-12 col-md-6">
                          <div id="tickets-table_filter" class="dataTables_filter text-md-end">
                              <label class="d-inline-flex align-items-center">
                                  Search:
                                  <b-form-input
                                          v-model="filter"
                                          type="search"
                                          placeholder="Search..."
                                          class="form-control form-control-sm ms-2"></b-form-input>
                              </label>
                          </div>
                      </div>
                      <!-- End search -->
                  </div>
                  <!-- Table -->
                  <div class="table-responsive mb-0">
                      <b-table
                              class="datatables"
                              :items="RadiologyPatients ? RadiologyPatients : []"
                              :fields="fields"
                              responsive="sm"
                              :per-page="perPage"
                              :current-page="currentPage"
                              :sort-desc.sync="sortDesc"
                              :filter="filter"
                              :filter-included-fields="filterOn"
                              @filtered="onFiltered">
                          <template #cell(index)="data">
                              {{ data.index + 1 }}
                          </template>
                          <template #cell(patient_services)="data">
                              <table class="table">
                                  <thead>
                                  <tr>
                                      <th>Service Name</th>
                                      <th>Date</th>
                                      <th>Action</th>
                                  </tr>
                                  </thead>
                                  <tbody>
                                  <tr v-for="(service, t) in data.item.radiology_services" :key="t">
                                      <td>{{ service.otherservice.name }}</td>
                                      <td>{{ service.date }}</td>
                                      <td>
                                          <b-button class="me-2" v-if="service.status==0" size="sm" variant="primary" @click="showResultModal(service)" v-b-modal.ServiceReportModel>
                                              <i class="fa fa-plus"></i> Add Report
                                          </b-button>
                                          <b-button class="me-2" v-else size="sm" variant="primary" @click="showResultModal(service)" v-b-modal.ServiceReportModel>
                                              <i class="fa fa-edit"></i> Edit Report
                                          </b-button>


                                          <span v-if="service.status==1">
                                              <router-link class="btn btn-secondary btn-sm" size="sm" :to="{name: 'Radiology_report', params: { id: service.id }}">
                                                  <i class="fa fa-print"></i>  Print Report
                                              </router-link>
                                          </span>
                                          <span v-else>
                                              <b-button size="sm" variant="warning">
                                                  <i class="fa fa-pause"></i> Pending
                                              </b-button>
                                          </span>
                                      </td>
                                  </tr>
                                  </tbody>
                              </table>
                          </template>
                      </b-table>
                      <center>
                          <h3 v-if="!RadiologyPatients" class="text-primary">
                              <b-spinner class="m-0" variant="primary" role="status"></b-spinner>
                              Please wait...
                          </h3>
                      </center>
                  </div>
                  <div class="row">
                      <div class="col">
                          <div class="dataTables_paginate paging_simple_numbers float-end">
                              <ul class="pagination pagination-rounded mb-0">
                                  <!-- pagination -->
                                  <b-pagination
                                          v-model="currentPage"
                                          :total-rows="rows"
                                          :per-page="perPage"
                                  ></b-pagination>
                              </ul>
                          </div>
                      </div>
                  </div>
              </div>
          </div>

             <!-- undefined Result Modal -->
             <b-modal size="lg" id="ServiceReportModel" @hidden="resetModal" hide-footer>
                 <template #modal-title>
                     <p class="text-uppercase">
                         Service Report Entry
                     </p>
                 </template>

                 <div class="mb-3">
                     <ckeditor v-model="serviceReport.report" :editor="editor"></ckeditor>
                 </div>

                 <div class="modal-footer">
                     <button
                             class="btn btn-secondary"
                             @click="$bvModal.hide('ServiceReportModel')"
                             type="button"
                     >
                         Close
                     </button>
                     <button @click="saveServiceReport('ServiceReportModel')"
                             class="btn btn-primary"
                             type="button">
                         Save result
                         <b-spinner v-if="RadioStatus"
                                 variant="light"
                                 small
                                 role="status"
                         ></b-spinner>
                     </button>
                 </div>
             </b-modal>
      
      </div>
    </div>
    </div>
  </Layout>
</template>
